/* eslint-disable */
export default {
  flipHeader: '將通話切換至...',
  flip: '切換',
  complete: '完成切換',
} as const;

// @key: @#@"flipHeader"@#@ @source: @#@"Flip Call to..."@#@
// @key: @#@"flip"@#@ @source: @#@"Flip"@#@
// @key: @#@"complete"@#@ @source: @#@"Complete Flip"@#@
